<template>
  <ContactSection/>
</template>

<script>
import ContactSection from "@/components/ContactSection";

export default {
  name: "Contact",
  components: {
    ContactSection,
  },
  mounted(){
    this.setMetaTags({
      title: 'VG-elektrotechnik - Kontakt',
      desc: 'Küldjön nekünk üzenetet!',
      keywords: 'Contact',
      ogType: 'website',
      ogTitle: 'VG-elektrotechnik - Kontakt',
      ogImage: '/images/main2.jpg',
      ogImageWidth: 600,
      ogImageHeight: 315,
      ogDesc:'Küldjön nekünk üzenetet!'
    })
  },
}
</script>

<style scoped>

</style>